/**
 * Cliente API de categorias.
 *
 * Sprint 12 S12-04: list para selector en clasificacion de pagos.
 * Sprint 13 S13-23: CRUD completo para mantenedor en sa.
 */
import { apiFetch } from './client';
import type { CategoriaRead, TipoCategoria } from './types';

export interface CategoriaCreate {
  nombre: string;
  tipo: TipoCategoria;
  color: string;
  activa?: boolean;
  /** Fondos de terceros (campañas): fuera de recaudación/gastos del barrio. */
  es_fondo_terceros?: boolean;
  categoria_padre_id?: string | null;
}

export interface CategoriaUpdate {
  nombre?: string;
  tipo?: TipoCategoria;
  color?: string;
  activa?: boolean;
  es_fondo_terceros?: boolean;
  // Pasar `null` explicitamente para des-asociar del padre (volver raiz).
  categoria_padre_id?: string | null;
}

export function listCategorias(filtros: {
  tipo?: TipoCategoria;
  activa?: boolean;
} = {}): Promise<CategoriaRead[]> {
  const params = new URLSearchParams();
  if (filtros.tipo) params.set('tipo', filtros.tipo);
  if (filtros.activa !== undefined) params.set('activa', String(filtros.activa));
  const qs = params.toString();
  return apiFetch<CategoriaRead[]>(`/categorias/${qs ? `?${qs}` : ''}`);
}

export function crearCategoria(data: CategoriaCreate): Promise<CategoriaRead> {
  return apiFetch<CategoriaRead>('/categorias/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function actualizarCategoria(
  id: string,
  data: CategoriaUpdate,
): Promise<CategoriaRead> {
  return apiFetch<CategoriaRead>(`/categorias/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

// Soft delete: el backend marca activa=false y retorna el recurso.
export function desactivarCategoria(id: string): Promise<CategoriaRead> {
  return apiFetch<CategoriaRead>(`/categorias/${id}`, { method: 'DELETE' });
}
